export const AGENT_REQUEST_LOADING = "AGENT_REQUEST_LOADING";
export const AGENT_REQUEST_SUCCESS = "AGENT_REQUEST_SUCCESS,";
export const AGENT_REQUEST_FAIL = "AGENT_REQUEST_FAIL";
export const GET_AGENT_PORTAL = "GET_AGENT_PORTAL";
export const REMOVE_AGENT_REQUEST_DATA = "REMOVE_AGENT_REQUEST_DATA";
